import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query GeneratePreview($landingPageAssetId: ID!, $htmlText: String!) {
    generatePreview(landingPageAssetId: $landingPageAssetId, htmlText: $htmlText) {
      screenshotBase64
      screenshotId
      screenshotUrl
    }
  }
`;

export const queryCOGeneratePreview = ({ landingPageAssetId, htmlText }, options) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      landingPageAssetId,
      htmlText,
    },
    options,
  }).then(({ data }) => getSingleProp(data));
};
